import { Controller } from "@hotwired/stimulus"

// działa na zasadzie połączenia data-tab-name z tabsTargets (lub id z odpowiadającego panelsTargets),
// w przeciwnym razie łączy po indeksie — kompatybilność wsteczna z innymi widokami
// zapisuje w URL aktualny tab, by odświeżenie wracało na odpowiedni tab
export default class extends Controller {
  static values = { visibleClass: String, hiddenClass: String, paramName: { type: String, default: "tab" }, scrollTop: { type: Boolean, default: false }, anchorTab: String, anchor: String }
  static targets = ["tabs", "panels", "stickyBar", "allBar"]

  connect() {
    if (this.anchorTabValue) {
      this.activateTabByName(this.anchorTabValue, false)
      return this.scrollToAnchor()
    }

    const urlParams = new URLSearchParams(window.location.search)
    const tabParam = urlParams.get(this.paramNameValue)

    if (tabParam === "all") {
      this.showAll(false)
    } else if (tabParam) {
      this.activateTabByName(tabParam, false)
    } else if (window.location.hash) {
      this.activateTabForAnchor(window.location.hash)
    } else {
      this.activateTabByIndex(0, false)
    }
  }

  scrollToAnchor() {
    const element = document.getElementById(this.anchorValue.replace(/^#/, ""))
    if (!element) return
    setTimeout(() => element.scrollIntoView({ behavior: "smooth", block: "start" }), 100)
  }

  activateTabForAnchor(hash) {
    const element = document.getElementById(hash.replace("#", ""))
    if (!element) return this.activateTabByIndex(0, false)

    const panel = this.panelsTargets.find(p => p.contains(element))
    if (!panel) return this.activateTabByIndex(0, false)

    // szukamy przycisku który pasuje do panelu — po data-tab-name lub po indeksie
    const panelId = panel.dataset.tabName || panel.id.replace(/^tabs-/, "")
    const tabIndex = this.tabsTargets.findIndex(t => this.getTabName(t) === panelId)
    if (tabIndex === -1) return this.activateTabByIndex(0, false)

    this.updateTabsAndPanels(tabIndex, panel)
    setTimeout(() => element.scrollIntoView({ behavior: "smooth", block: "start" }), 100)
  }

  toggleTab(event) {
    event.preventDefault()
    const tabName = this.getTabName(event.currentTarget)
    if (tabName === "all") {
      this.showAll()
    } else {
      this.activateTabByName(tabName)
    }
    if (this.scrollTopValue) window.scrollTo({ top: 0 })
  }

  showAll(updateHistory = true) {
    if (this.hasVisibleClassValue) {
      this.tabsTargets.forEach((tab) => {
        tab.className = this.hiddenClassValue
      })
      const allTab = this.tabsTargets.find(t => this.getTabName(t) === "all")
      if (allTab) allTab.className = this.visibleClassValue
    }

    this.panelsTargets.forEach(panel => panel.classList.remove("hidden"))
    this.stickyBarTargets.forEach(bar => bar.classList.add("hidden"))
    if (this.hasAllBarTarget) this.allBarTarget.classList.remove("hidden")
    this.element.dataset.tabsShowAll = 'true'

    if (updateHistory) {
      this.updateUrlHistory("all")
    }
  }

  activateTabByName(tabName, updateHistory = true) {
    let targetTabIndex = -1
    let targetPanel = null

    this.tabsTargets.forEach((tab, i) => {
      const elementTabName = this.getTabName(tab)
      if (elementTabName === tabName) {
        targetTabIndex = i
      }
    })

    if (targetTabIndex >= 0) {
      targetPanel = this.panelsTargets.find(panel =>
        panel.dataset.tabName === tabName || panel.id === tabName
      )
      if (!targetPanel && targetTabIndex < this.panelsTargets.length) {
        targetPanel = this.panelsTargets[targetTabIndex]
      }

      if (targetPanel) {
        this.updateTabsAndPanels(targetTabIndex, targetPanel)
        if (updateHistory) {
          this.updateUrlHistory(tabName)
        }
      }
    }
  }

  activateTabByIndex(activeIndex, updateHistory = true) {
    if (activeIndex >= 0 && activeIndex < this.tabsTargets.length && activeIndex < this.panelsTargets.length) {
      const targetPanel = this.panelsTargets[activeIndex]
      this.updateTabsAndPanels(activeIndex, targetPanel)
      if (updateHistory) {
        const tabName = this.getTabName(this.tabsTargets[activeIndex])
        this.updateUrlHistory(tabName)
      }
    }
  }

  updateTabsAndPanels(activeIndex, activePanel) {
    if (this.hasVisibleClassValue) {
      this.tabsTargets.forEach((tab, index) => {
        tab.className = (index === activeIndex) ? this.visibleClassValue : this.hiddenClassValue
      })
    }
    delete this.element.dataset.tabsShowAll
    this.stickyBarTargets.forEach(bar => bar.classList.remove("hidden"))
    if (this.hasAllBarTarget) this.allBarTarget.classList.add("hidden")
    this.panelsTargets.forEach((panel) => {
      if (panel === activePanel) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  getTabName(tabElement) {
    if (tabElement.dataset.tabName) {
      return tabElement.dataset.tabName
    }

    const tabIndex = this.tabsTargets.indexOf(tabElement)
    const correspondingPanel = this.panelsTargets[tabIndex]

    if (correspondingPanel && correspondingPanel.id) {
      return correspondingPanel.id
    }

    return `tab-${tabIndex}`
  }

  updateUrlHistory(tabName) {
    const url = new URL(window.location)
    url.searchParams.set(this.paramNameValue, tabName)
    url.hash = ""
    window.history.replaceState({}, "", url.toString())
  }
}
